<template>
    <div class="" :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <form action="" class="form form--floating-label" :class="{hidden: loading}" @submit.prevent="formSubmit" ref='form' >
        <div class="style-h2 mb-4">
            User Profile
        </div>

        <div class="mb-5">
            <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.email, error: submittedOnce && errors.email}">
                <input
                        id="email"
                        type="email"
                        v-model="formData.email"
                        class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                />
                <label for="email" class="absolute left-2 transition-all px-1 text-blue-gray">
                    Email Address
                </label>
            </div>
            <div v-if="submittedOnce && errors.email " class="text-red text-sm mt-2 leading-none">
                {{ errors.email }}
            </div>
        </div>

        <div class="mb-5">
            <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.first_name, error: submittedOnce && errors.first_name}">
                <input
                        id="first_name"
                        type="text"
                        v-model="formData.first_name"
                        class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
                />
                <label for="first_name" class="absolute left-2 transition-all px-1 text-blue-gray">
                    First Name
                </label>
            </div>

            <div v-if="submittedOnce && errors.first_name " class="text-red text-sm mt-2 leading-none">
                {{ errors.first_name }}
            </div>
        </div>

        <div class="mb-5">
            <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.last_name, error: submittedOnce && errors.last_name}">
                <input
                        id="last_name"
                        type="text"
                        v-model="formData.last_name"
                        class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
                />
                <label for="last_name" class="absolute left-2 transition-all px-1 text-blue-gray">
                    Last Name (optional)
                </label>
            </div>
            <div v-if="submittedOnce && errors.last_name " class="text-red text-sm mt-2 leading-none">
                {{ errors.last_name }}
            </div>
        </div>

        <div class="mb-5">
            <div class="input-container input-container--floating relative h-12" :class="{empty: !formData.phone , error: submittedOnce && errors.phone}">
                <input
                        id="phone"
                        type="text"
                        v-model="formData.phone"
                        class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                />
                <label for="phone" class="absolute left-2 transition-all px-1 text-blue-gray">
                    Phone (optional)
                </label>
            </div>
            <div v-if="submittedOnce && errors.phone" class="text-red text-sm mt-2 leading-none">
                {{ errors.phone }}
            </div>
        </div>





        <div v-if="submittedOnce && errors.message" class="bg-red text-white mt-10 mb-5 px-3 py-2 rounded ">
            {{ errors.message }}
        </div>

        <div v-if="successMessage" class="bg-blue-success text-white mb-5 px-3 py-2 rounded ">
            {{ successMessage }}
        </div>

        <div class="mt-10 flex flex-col md:flex-row items-center ">
            <button type="submit" class="btn w-full md:w-auto">Update User Details</button>
        </div>
    </form>
</template>

<script charset="utf-8">

import { values, join, get, assign, pick } from 'lodash';
import Loading from '../includes/Loading.vue';
import Vuex from 'vuex';

export default {
    name: 'ProfileForm',
    data() {
        return {
            formData: {
                first_name: '',
                last_name: '',
                email: '',
                phone: ''
            },
            successMessage: '',
            loading: false,
            submittedOnce: false,

            errors: {
                first_name: 'This field is required',
                email: 'This field is required',
            }
        }
    },

    components: {
        Loading
    },

    emits: ["submit-success"],

    created() {
        this.formData = assign({}, this.formData, pick(this.profile, [
            'first_name', 'last_name', 'email', 'phone',
        ]));
    },

    watch: {
        formData: {
            handler(newVal){
                this.errors.message = '';
                this.errors.first_name = newVal.first_name ? '' : 'This field is required';
                this.errors.email   = newVal.email  ? '' : 'This field is required';
                this.errors.phone   =  (!newVal.phone || !newVal.phone.length || newVal.phone.length >= 7) ? '' : 'Phone need to have at least 7 numbers';
            },
            deep: true
        }
    },

    computed: {
        ...Vuex.mapGetters('profile', {
            profile: 'profile',
        })
    },

    methods: {
        ...Vuex.mapActions('profile', {
            updateUser: 'updateUser',
        }),


        formSubmit() {
            this.submittedOnce = true;
            this.errors.message = '';

            if (join(values(this.errors), '')) {
                return;
            }

            let data = {
                first_name: this.formData.first_name,
                last_name: this.formData.last_name,
                phone: this.formData.phone,
                email: this.formData.email
            }

            this.loading = true;
            this.updateUser(data).then((res) => {
                this.$emit('submit-success');
                this.loading = false;
                this.successMessage = 'User profile has been updated';
            }).catch(err => {
                this.loading = false;
                this.errors = {
                    username: get(err, 'response.data.errors.username[0]'),
                    email: get(err, 'response.data.errors.email[0]'),
                    message: 'Invalid data'
                }
            });

        },
    }
}
</script>
